import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges, ViewChild, ElementRef, AfterViewInit } from '@angular/core';

/**
 * ID: bh-content-search
 * Name: BH Content Search
 * Description: Displays standardized search bar
 * Version: 2
 *
 * ==============================
 * Change Log
 * ==============================
 * 2021-07-02 - MW - v1: Initial dev
 * 2021-10-11 - MW - v2: Added focus style and clear-focus
 */
@Component({
  selector: 'bh-content-search',
  templateUrl: './bh-content-search.component.html',
  styleUrls: ['./bh-content-search.component.scss'],
})
export class BhContentSearchComponent implements OnChanges {

  @Input() placeholder = 'Search';
  @Input() layout: 'block' | 'compact' = 'block';
  @Input() showSearchButton = false;
  @Input() disabled = false;
  @Input() searchTerm = '';
  @Output() searchEvent = new EventEmitter();
  @ViewChild('searchInput', { static: true }) searchInput: any;
  isFocused = false;
  timer = null;

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    // console.log('changes:', changes);
    if ('searchTerm' in changes) {
      // console.log('searchTerm', this.searchTerm);
      this.searchEvent.emit(this.searchTerm);
    }
  }

  search() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    this.timer = setTimeout(() => {
      this.searchEvent.emit(this.searchTerm);
    }, 500);
  }

  clearSearch() {
    this.searchTerm = '';
    this.searchInput.nativeElement.focus();
    this.search();
  }

  onFocus(isFocused) {
    this.isFocused = isFocused;
  }

}
